export default __webpack_public_path__ + "static/media/settings.a68f9e47.svg";